import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M26.5701 2.78999C31.0601 4.89999 36.4 11.31 35.91 27.16C35.42 43.01 23.17 63.53 6.04004 59.24C6.04004 59.24 14.97 58 11.95 45.75C8.93004 33.5 4.60004 20.41 8.98004 10.71C13.37 1.01 22.6201 0.939994 26.5701 2.78999Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.28003 59.38C9.28003 59.38 18.55 57.87 18.75 47.37C19.09 29.78 11.42 10.91 20.78 4.03003C20.78 4.03003 25.85 7.38003 28.33 23.09C29.98 33.53 28 57.17 12.51 59.43"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M20.7901 4.03003C20.7901 4.03003 6.91006 7.76003 13.7301 35.85C17.3501 50.79 15.2201 57.25 9.81006 58.74"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M66.61 2.78999C62.12 4.89999 56.78 11.31 57.27 27.16C57.76 43.01 70.01 63.53 87.14 59.24C87.14 59.24 78.21 58 81.23 45.75C84.25 33.5 88.58 20.41 84.2 10.71C79.82 1.01 70.55 0.939994 66.61 2.78999Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M83.9 59.38C83.9 59.38 74.63 57.87 74.43 47.37C74.09 29.78 81.76 10.91 72.4 4.03003C72.4 4.03003 67.33 7.38003 64.85 23.09C63.2 33.53 65.18 57.17 80.67 59.43"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M72.39 4.03003C72.39 4.03003 86.27 7.76003 79.45 35.85C75.83 50.79 77.96 57.25 83.37 58.74"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
